"use strict";import{tag as s}from"../custom-tag.js";export function assessmentIcon({height:e=16,width:t=16,hidden:l=!1,title:r="Assessment"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        d="M5.5 22q-.6 0-1.05-.45T4 20.5v-17q0-.6.45-1.05T5.5 2H14l6 6v4.95l-7 7V22zm9 0v-1.425l5.075-5.05 1.45 1.375-5.1 5.1zm7.2-5.775-1.425-1.4.8-.775q.225-.2.538-.2.312 0 .512.2l.325.35q.225.226.225.537a.73.73 0 0 1-.225.538zM13 9h5.5L13 3.5z"
      />
    </svg>
  `}
//# sourceMappingURL=assessment.js.map
